

















import { Component, Vue, Prop } from 'vue-property-decorator'
import { Workspace } from '@shared/types/database'
import floopLogo from '../../../assets/img/floop-logo.png'

@Component({ components: { } })
export default class WorkspaceCard extends Vue {
  @Prop() readonly workspace!: Workspace
  fallbackLogo = floopLogo
}
